import React from "react";
import classNames from "classnames";
import Image from "next/image";
import Paragraphs from "./Paragraphs";
const IconItems = (props) => {
  const items = props?.items && Array.isArray(props?.items) ? props?.items : [];

  const styles = {
    container: props?.classes?.container || "base-container base-grid",
    cardContainer:
      props?.classes?.container || "col-span-10 col-start-2 base-grid",
    card: props?.classes?.card || "col-span-12 md:col-span-4 text-center ",
    iconContainer:
      props?.classes?.iconContainer ||
      "bg-main-blue w-16 h-16 rounded-full flex mx-auto justify-center md:bg-main-orange",
    icon: props?.classes?.icon || "max-w-full",
    paragraphsContainer: props?.classes?.paragraphsContainer || "pt-4",
  };
  return (
    <div className={classNames(styles?.container)}>
      <div className={classNames(styles?.cardContainer)}>
        {(items &&
          items.map((item, key) => {
            return (
              <div key={key} className={classNames(styles?.card)}>
                {(item?.icon && (
                  <div className={classNames(styles?.iconContainer)}>
                    <Image
                      alt={item?.icon?.alt}
                      src={item?.icon?.src}
                      height={item?.icon?.height}
                      width={item?.icon?.width}
                      className={classNames(styles?.icon)}
                    />
                  </div>
                )) ||
                  ""}
                <div className={classNames(styles?.paragraphsContainer)}>
                  <Paragraphs items={item?.paragraphs} />
                </div>
              </div>
            );
          })) ||
          ""}
      </div>
    </div>
  );
};
export default IconItems;
